import React, { useContext } from "react";
import { MdFilterList } from "react-icons/md";
import COLORS from "scss/colors.module.scss";
import styled, { css } from "styled-components";
import FilterPopup from "./Filter/FilterPopup";
import { observer } from "mobx-react";
import { ContainerStoreContext, ViewStoreContext } from "../ContainerStore";
import { isEmpty } from "lodash";
import StyledToolbarButton, { StyledToolbarTitle } from "./StyledToolbarButton";

function Filter() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isOpen, setOpen] = React.useState(false);
  const containerStore = useContext(ContainerStoreContext);
  const currentViewStore = useContext(ViewStoreContext);
  const view = containerStore.view;

  return (
    <>
      <StyledToolbarButton
        highlighted={
          currentViewStore?.isCriteriaModified
            ? !isEmpty(currentViewStore?.modifiedCriteria)
            : !isEmpty(containerStore.view.criteria)
        }
        className="d-flex"
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
          setOpen(true);
        }}
      >
        <MdFilterList size={18} />
        <StyledToolbarTitle>Filter</StyledToolbarTitle>
      </StyledToolbarButton>
      <FilterPopup
        anchorEl={anchorEl}
        onClose={() => setOpen(false)}
        isOpen={isOpen}
      />
    </>
  );
}

export default observer(Filter);
